import React from "react";
import Image from "./Image";

// const imagesList = {
//   w_jej_dloniach: "W jej dłoniach",
//   arlekin: "Arlekin",
//   pan_i_psy: "Pan i psy",
//   zoo: "ZOO",
//   emancypacja: "Emancypacja"
// };

// const answersList = [
//   {
//     dziecko: "Kobieta trzymająca dziecko",
//     skrzypce: "Kobieta trzymająca skrzypce",
//     pies: "Kobieta trzymająca psa",
//     kot: "Kobieta trzymająca kota",
//     malpa: "Kobieta trzymająca małpę"
//   },
//   {
//     gniazdo: "Gniazdo",
//     para: "Para",
//     starzec: "Starzec w jarmułce",
//     arlekinenface: "Arlekin en face",
//     profil: "Profil arlekina"
//   },
//   {
//     czterypsy: "Człowiek i cztery psy",
//     czteryinne: "Człowiek i cztery inne psy",
//     piecpsow: "Człowiek i pięć psów"
//   },
//   {
//     cztery: "Żyrafa, dingo, kobra, sęp",
//     slon: "Słoń",
//     piec: "Nosorożec, jeleń, koza, zebra, niedźwiedź"
//   },
//   {
//     ptaki: "Ptaki",
//     men: "Mężczyzna",
//     women: "Kobieta współczesna",
//     czepek: "Panienka w czepku"
//   }
// ];

export default class Quiz extends React.Component {
  state = {
    acf: false,
    wp: false,
    currentIndex: 0,
    answered: false,
    points: 0,
    quizStarted: false
  };
  componentDidMount = () => {
    fetch(
      "https://arteco-wp.prod.krzysztofsikorski.pl/wp-json/acf/v3/posts?tags=8&per_page=100"
    )
      .then(response => {
        return response.json();
      })
      .then(myJson => {
        this.setState({
          acf: myJson
        });
      });

    fetch(
      "https://arteco-wp.prod.krzysztofsikorski.pl/wp-json/wp/v2/posts?tags=8&per_page=100&_fields=title,id,categories"
    )
      .then(response => {
        return response.json();
      })
      .then(myJson => {
        this.setState({
          wp: myJson
        });
      });
  };
  // answerCorrect = content => {
  //   return content === answersList[this.state.currentIndex][0];
  // };
  clickOnAnswer = content => {
    this.setState(state => {
      state.answered = content;
      return state;
    });
  };
  goPrev = () => {
    this.setState(state => {
      state.currentIndex--;
      state.answered = false;
      return state;
    });
  };
  goNext = () => {
    this.setState(state => {
      state.currentIndex++;
      state.answered = false;
      return state;
    });
  };
  render() {
    if (!this.state.wp || !this.state.acf) return null;

    const { wp, acf } = this.state;
    console.log(wp);
    const answersList = wp
      .map(post => ({
        title: post.title.rendered,
        front: acf.find(el => el.id === post.id).acf.front,
        back: acf.find(el => el.id === post.id).acf.back,

        warianty1: acf.find(el => el.id === post.id).acf.warianty1,
        warianty2: acf.find(el => el.id === post.id).acf.warianty2,
        warianty3: acf.find(el => el.id === post.id).acf.warianty3,
        warianty4: acf.find(el => el.id === post.id).acf.warianty4,
        warianty5: acf.find(el => el.id === post.id).acf.warianty5,
        warianty6: acf.find(el => el.id === post.id).acf.warianty6
      }))
      .map(post => ({
        ...post,
        variants: [
          post.warianty1,
          post.warianty2,
          post.warianty3,
          post.warianty4,
          post.warianty5,
          post.warianty6
        ].filter(variant => variant && variant.obraz)
      }));
    console.log(answersList);
    const { currentIndex } = this.state;
    return (
      <div>
        {this.state.quizStarted || (
          <div className="container" style={{ maxWidth: "700px" }}>
            <div
              className="content bodyfont"
              style={{
                padding: "100px 20px",
                fontSize: "18px",
                lineHeight: "1.8em"
              }}
            >
              <div>
                Lubisz zagadki? Chcesz rozwijać swoją wyobraźnię wzrokową? Jeśli
                tak to zapraszamy do nietypowego guizu. Wyróżnia go to, że
                wszystkie warianty odpowiedzi są poprawne. Zadanie polega na
                znalezieniu (w obrębie danej fotografii) obiektów opisanych w
                poszczególnych podpunktach. Klikając na te podpunkty można
                sprawdzić w jakim stopniu Twoja wizja jest zbieżna z wizją
                autorki. Gdy naprowadzisz myszkę na zdjęcie z naniesionym
                rysunkiem, obraz obróci się ukazując grafikę. Niektóre obrazy
                mają dodatkowo opisy słowne. Może zdarzyć się, że oglądając
                zdjęcie zobaczysz jeszcze coś innego. W takim wypadku podziel
                się z nami swoimi spostrzeżeniami.
                <br />
                <br />
                <a
                  style={{
                    background:
                      "rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%",
                    color: "black"
                  }}
                  className="button"
                  onClick={() => this.setState({ quizStarted: true })}
                >
                  Rozpocznij quiz
                </a>
              </div>
            </div>
          </div>
        )}
        <div style={{ margin: "64px auto", maxWidth: 900 }}>
          {this.state.quizStarted && (
            <React.Fragment>
              {currentIndex > 0 && (
                <div
                  style={{
                    position: "fixed",
                    left: 15,
                    top: "50%",
                    cursor: "pointer"
                  }}
                  onClick={this.goPrev}
                >
                  <i className="fal fa-angle-left fa-4x"></i>
                </div>
              )}
              <Image
                clickOnAnswer={this.clickOnAnswer}
                image={answersList[currentIndex]}
                {...this.state}
              />
              {currentIndex < answersList.length - 1 && (
                <div
                  style={{
                    position: "fixed",
                    right: 15,
                    top: "50%",
                    cursor: "pointer"
                  }}
                  onClick={this.goNext}
                >
                  <i className="fal fa-angle-right fa-4x"></i>
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Quiz.js